<template>
    <div class="main-section home center">
        <div class="products-grid row wrap center">
            <div class="product-grid-title"><h3>Productos destacados</h3></div>
            <div class="box-product columns space-around product-hover-card center" v-for="(product,index) in homeProducts" :key="index" v-on:click="ProductDetail(product)" v-on:mouseover="HoverIndex(index)" v-on:mouseleave="HoverIndex(-1)">
                <div class="pointer" @click="GetProductBySlug(product.slug)">
                    <img onerror="this.src='https://images.gofarma.com.mx/fallback.jpeg';" :alt="product.slug" :src="imgSource+product.sku+'-1.jpeg'">
                    <div class="parent-container">
                        <div class="product-container">
                            <p class="product-name">{{product.name}}</p>
                        </div>
                    </div>

                    <div class="product-info">
                        <!-- If product has discount -->
                        <div v-if="product.basePrice !== product.lowerIndividualPriceForWeb">
                            <span class="discount-cost">{{product.basePrice | to-currency}}</span><br>
                            <span class="cost">{{product.lowerIndividualPriceForWeb | to-currency}}</span>
                            <span class="today-only">SOLO HOY</span>
                        </div>

                        <!-- If product has no discounts -->
                        <div v-else>
                            <span class="cost">{{product.basePrice | to-currency}}</span>
                        </div>
                    </div>
                </div>

                <!-- Desktop and tablet buttons -->
                <button v-if="hoverIndex===index" class="btn" :class="product.available ? 'btn-primary' : 'btn-light'" @click="AddRawProduct( {product: product, quantity: 1} )" data-not-narrow-mode>
                    <span class="bold" v-if="product.available" style="color: white">Agregar al carrito</span>
                    <span class="bold" v-else style="color: white">Sobre pedido</span>
                </button>

                <!-- Mobile only button -->
                <button class="btn" :class="product.available ? 'btn-primary' : 'btn-light'" @click="AddRawProduct( {product: product, quantity: 1} )" data-not-wide-mode data-not-medium-mode>
                    <span class="bold" v-if="product.available" style="color: white">Agregar al carrito</span>
                    <span class="bold" v-else style="color: white">Sobre pedido</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
    name:'ProductsGrid',
    data(){
        return{
            imgSource:"https://images.gofarma.com.mx/"
        }
    },
    methods:{
        HoverIndex(index){
            let hoverIndex = index
            this.$store.commit('StateAssign',{hoverIndex})
        },
        ...mapActions(['ProductDetail', 'AddRawProduct','GetProductBySlug'])
    },
    computed:{
        ...mapState([
            'homeProducts',
            'hoverIndex'
        ]),
    
    }
}

</script>

<style>
@import '../variables.css';

.columns.space-around {
    justify-content: space-around;
}

.product-hover-card{
    width:17.5rem;
    height:18.75rem;
    text-decoration:none;
}

.product-grid-title{
    text-align:left;
    width:90%;
}
.parent-container{
    width:90%;
    text-align:left
}
.product-name{
     margin:0;
}

.product-cost-discount{
   /* text-decoration: line-through;
    color: red;*/
    padding: 0 0.3125rem;
    text-align: left;
    color: var(--dark-gofarma);
    width: 90%;
}
.box-product {
    position: relative;
    box-shadow: 0 0rem 0rem 0 rgba(0, 0, 0, 0);
    transition: 0.3s;
    margin: 0.3125rem;
    box-sizing: border-box;
}
.box-product:hover{
    box-shadow: 0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.212);
}
a {
    color: #4183c4;
    text-decoration: none;
}
a {
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
}

.home, .main-section {
    padding: 0.625rem 8% 0.625rem 8%;
}

.box-product .availability {
    position: absolute;
    top: 0.625rem;
    right: 0.625rem;
    padding: 0.25rem;
    background-color: var(--dark-gofarma);
    border-radius: 0.3125rem;
    z-index: 10;
    font-size: 0.75rem;
    color: white;
    font-weight: bold;
}

.product-container {
    width: 80%;
    text-align:left;
    padding: 0 0.3125rem;
}

.box-product img {
    height: 8.75rem;
    width: auto;
    max-width: 80%;
}
</style>